import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getData, postData } from '../Services/api'
import { toast } from 'react-toastify'

const FooterInfoUpdate = () => {
    const [values, setValues] = useState({
        stats: {
            happyCustomers: "",  // "50K+"
            averageRating: "",   // "4.9"
            products: "",        // "100+"
            satisfactionRate: "" // "98%"
        },
        contact: {
            phone: "",
            address: "",
            email: "",
            socialLinks: {
                instagram: "",
                youtube: "",
                twitter: "",
                facebook: ""
            }
        }
    })

    const [loading, setLoading] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Split nested keys, e.g. "stats.happyCustomers"
        const keys = name.split(".");

        setValues(prev => {
            let temp = { ...prev };

            let current = temp;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!current[keys[i]]) current[keys[i]] = {};
                current = current[keys[i]];
            }

            current[keys[keys.length - 1]] = value;

            return temp;
        });
    };




    const fetchFooterInfo = async () => {
        try {
            const res = await getData('/footer-info');
            if (res.status) {
                const data = res.data || {}; // fallback if null
                setValues({
                    stats: {
                        happyCustomers: data.stats?.happyCustomers || "",
                        averageRating: data.stats?.averageRating || "",
                        products: data.stats?.products || "",
                        satisfactionRate: data.stats?.satisfactionRate || ""
                    },
                    contact: {
                        phone: data.contact?.phone || "",
                        address: data.contact?.address || "",
                        email: data.contact?.email || "",
                        socialLinks: {
                            instagram: data.contact?.socialLinks?.instagram || "",
                            youtube: data.contact?.socialLinks?.youtube || "",
                            twitter: data.contact?.socialLinks?.twitter || "",
                            facebook: data.contact?.socialLinks?.facebook || ""
                        }
                    }
                });
            }
        } catch (error) {
            console.log("error fetch footer", error);
        }
    }


    useEffect(() => {
        fetchFooterInfo();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {

            const res = await postData('/footer-info', values);
            if (res.status) {
                toast.success(res.message)

            }
        } catch (error) {
            console.log("error footer adding",)
            toast.error(error.data.response.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Update Footer Info
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Update Footer Info</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Update Footer Info</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Happy Customers</label>
                                                    <input type="text"
                                                        name="stats.happyCustomers"
                                                        value={values.stats.happyCustomers}
                                                        onChange={handleChange}
                                                        className='form-control'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Average Rating</label>
                                                    <input type="text"
                                                        name="stats.averageRating"
                                                        value={values.stats.averageRating}
                                                        onChange={handleChange}
                                                        className='form-control'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Products</label>
                                                    <input type="text"
                                                        name="stats.products"
                                                        value={values.stats.products}
                                                        onChange={handleChange}
                                                        className='form-control'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Satisfaction Rate</label>
                                                    <input type="text"
                                                        name="stats.satisfactionRate"
                                                        value={values.stats.satisfactionRate}
                                                        onChange={handleChange}
                                                        className='form-control'
                                                    />
                                                </div>
                                            </div>
                                            <h4>Contact</h4>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label">Phone</label>
                                                    <input type="text" name="contact.phone" className='form-control' value={values.contact.phone} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label">Address</label>
                                                    <input type="text" name="contact.address" className='form-control' value={values.contact.address} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label">Email</label>
                                                    <input type="email" name="contact.email" className='form-control' value={values.contact.email} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <h5>Social Links</h5>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Instagram</label>
                                                    <input type="text" name="contact.socialLinks.instagram" className='form-control' value={values.contact.socialLinks.instagram} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">YouTube</label>
                                                    <input type="text" name="contact.socialLinks.youtube" className='form-control' value={values.contact.socialLinks.youtube} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Twitter</label>
                                                    <input type="text" name="contact.socialLinks.twitter" className='form-control' value={values.contact.socialLinks.twitter} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="form-label">Facebook</label>
                                                    <input type="text" name="contact.socialLinks.facebook" className='form-control' value={values.contact.socialLinks.facebook} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Updating...' : 'Update'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FooterInfoUpdate